module.exports = __webpack_public_path__ + "img/arrow-up-pink.e786c2ab.svg";